<template>
    <div>
      <h3>Cargar Múltiples Archivos</h3>
      <form @submit.prevent="cargarArchivos">
        <div class="input-group">
          <label for="idPedido">ID del Pedido:</label>
          <input v-model="idPedido" type="text" placeholder="Ingrese ID del Pedido" required />
        </div>
        <div class="input-group">
          <label for="archivos">Seleccionar Archivos:</label>
          <input type="file" @change="onFileChange" multiple required />
        </div>
        <button type="submit">Cargar Archivos</button>
      </form>
    </div>
  </template>
  
  <script>
  import api from "@/services/api";
  
  export default {
    data() {
      return {
        idPedido: '',
        archivos: [] // Almacena los archivos seleccionados
      };
    },
    methods: {
      onFileChange(e) {
        this.archivos = e.target.files; // Almacena los archivos seleccionados
      },
      async cargarArchivos() {
        const formData = new FormData();
        formData.append('idPedido', this.idPedido);
  
        // Añadir cada archivo seleccionado al FormData
        for (let i = 0; i < this.archivos.length; i++) {
          formData.append('archivos', this.archivos[i]);
        }
  
        try {
          const response = await api.post('/archivos/indexar', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });
          alert('Archivos cargados e indexados correctamente'+response);
        } catch (error) {
          console.error('Error al cargar archivos:', error);
          alert('Error al cargar archivos');
        }
      }
    }
  };
  </script>
  
  <style scoped>
  /* Estilos básicos */
  .input-group {
    margin-bottom: 15px;
  }
  
  .input-group label {
    display: block;
    font-weight: bold;
  }
  
  .input-group input {
    width: 100%;
    padding: 10px;
    margin-top: 5px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  
  button {
    background-color: #4CAF50;
    color: white;
    border: none;
    padding: 10px 15px;
    cursor: pointer;
    border-radius: 5px;
  }
  
  button:hover {
    background-color: #45a049;
  }
  </style>  